module.exports = __webpack_public_path__ + "static/media/routeSquare.b40ab23d.svg";